module.exports = __webpack_public_path__ + "img/ball_4_green.0d72e076.png";